// @flow
const initialState = {
    isLoading:false,
    isEnableCreditCard: false,
    isEnableDebitCard: false,
    isEnableNetbanking: false,
    isEnableUPI1: false,
    isEnableUPI2: false,
    isEnableUPI3: false,
    isEnableUPI4: false,
    isEnableUPI5: false,
    isEnableWallet1:false,
    isEnableWallet2:false,
    isEnableWallet3:false,
    paymentHash: "",
    transactionKey:"",
    retailPrice:0,
    isShare:false,
};

export default function pay(state= initialState, action:any) {
    switch (action.type) {
        case 'UPDATE_ADD_TO_CART_FULFILLED':
            return {...state,
                isEnableCreditCard:action.payload.data.OptionList.IsEnableCreditCard,
                isEnableDebitCard:action.payload.data.OptionList.IsEnableDebitCard,
                isEnableNetbanking:action.payload.data.OptionList.IsEnableNetbanking,
               
                isEnableUPI1: action.payload.data.OptionList.IsEnableUPI1,
                isEnableUPI2: action.payload.data.OptionList.IsEnableUPI2,
                isEnableUPI3: action.payload.data.OptionList.IsEnableUPI3,
                isEnableUPI4: action.payload.data.OptionList.IsEnableUPI4,
                isEnableUPI5: action.payload.data.OptionList.IsEnableUPI5,
              
                isEnableWallet1:action.payload.data.OptionList.IsEnableWallet1,
                isEnableWallet2:action.payload.data.OptionList.IsEnableWallet2,
                isEnableWallet3:action.payload.data.OptionList.IsEnableWallet3,
                paymentHash:action.payload.data.PaymentHash,
                isLoading:false,};        
        case 'GET_PAY_URL_TO_REDIRECT_PENDING':
            return {...state, isLoading:true,};
        case 'GET_PAY_URL_TO_REDIRECT_FULFILLED':
            return {...state,transactionId:action.payload.data.TransactionId, isLoading:false};        
        case 'GET_PAY_URL_TO_REDIRECT_REJECT':
            return {...state,isLoading:false}; 

        case 'GET_PAYMENT_OPTION_PENDING':
            return {...state,isLoading:true };

        case 'GET_PAYMENT_OPTION_FULFILLED':
            return {...state, isAuthenticated: true, 
                
                isEnableCreditCard:action.payload.data.IsEnableCreditCard,
                isEnableDebitCard:action.payload.data.IsEnableDebitCard,
                isEnableNetbanking:action.payload.data.IsEnableNetbanking,

                isEnableUPI1: action.payload.data.IsEnableUPI1,
                isEnableUPI2: action.payload.data.IsEnableUPI2,
                isEnableUPI3: action.payload.data.IsEnableUPI3,
                isEnableUPI4: action.payload.data.IsEnableUPI4,
                isEnableUPI5: action.payload.data.IsEnableUPI5,
              
                isEnableWallet1:action.payload.data.IsEnableWallet1,
                isEnableWallet2:action.payload.data.IsEnableWallet2,
                isEnableWallet3:action.payload.data.IsEnableWallet3,
                isLoading:false
            };
        case 'GET_PAYMENT_OPTION_REJECT':
            return {...state,isLoading:false};   
            
        case 'VERIFY_OTP_PENDING':
            return {...state,isLoading:true };

        case 'VERIFY_OTP_FULFILLED':
            return {...state, isAuthenticated: true, 
                paymentHash:action.payload.data.ValidCheckHash,
                isEnableCreditCard:action.payload.data.OptionList.IsEnableCreditCard,
                isEnableDebitCard:action.payload.data.OptionList.IsEnableDebitCard,
                isEnableNetbanking:action.payload.data.OptionList.IsEnableNetbanking,

                isEnableUPI1: action.payload.data.OptionList.IsEnableUPI1,
                isEnableUPI2: action.payload.data.OptionList.IsEnableUPI2,
                isEnableUPI3: action.payload.data.OptionList.IsEnableUPI3,
                isEnableUPI4: action.payload.data.OptionList.IsEnableUPI4,
                isEnableUPI5: action.payload.data.OptionList.IsEnableUPI5,
                
                isEnableWallet1:action.payload.data.OptionList.IsEnableWallet1,
                isEnableWallet2:action.payload.data.OptionList.IsEnableWallet2,
                isEnableWallet3:action.payload.data.OptionList.IsEnableWallet3,
                isLoading:false
            };
        case 'VERIFY_OTP_REJECT':
            return {...state,isLoading:false};  

        case 'LOGIN_IS_SHARE':
            return {...state,isLoading:false,isShare:action.payload};           
        case 'LOG_OUT':
            return state;

        case 'STORE_HASH_KEY':
            return {...state, paymentHash: action.payload , deliveryKey : action.deliveryKey};

        default:
            return state;
    }
}